import React from 'react';
import PropTypes from 'prop-types';
import PropagateLoader from 'react-spinners/PropagateLoader';
import './style.css';

const defaultInnerSpinner = () => (
  <PropagateLoader size={20} loading color="#3989E3" />
);

const Spinner = ({ wrapperClassName = '', messageClassName = '', InnerSpinner, message }) => (
  <div className={`spinner-area ${wrapperClassName}`}>
    <div className="inner-area">
      <div className="inner-spinner">
        <InnerSpinner />
      </div>
      {
        message
          ? (
            <div className={`spinner-under-message ${messageClassName}`}>
              { message }
            </div>
          )
          : null
      }
    </div>
  </div>
);

Spinner.propTypes = {
  wrapperClassName: PropTypes.string,
  messageClassName: PropTypes.string,
  InnerSpinner: PropTypes.func,
  message: PropTypes.string,
};

Spinner.defaultProps = {
  wrapperClassName: '',
  messageClassName: '',
  InnerSpinner: defaultInnerSpinner,
  message: '',
};

export default Spinner;
